import React, { Component } from 'react';
import sessionExpiredImage from '../../images/session_expired.svg';
import docuwareLogoBig from '../../images/DocuWareLogBig.svg';
import docuwareLogo from '../../images/DocuWareLogo32px.svg';
import { ReactComponent as IconButtonRounded } from '../../images/Icon-Button-Rounded.svg';
import { Translation } from "react-i18next";
import { useConfig } from '../../contexts/configContext';
import './SessionExpired.scss'

export const SessionExpired = () => {
    const _redirectToPreviousUrl = (): void => {
        window.history.back();
    }

    const config = useConfig();
    const docuwareBaseUrl = "https://start.docuware.com/";
    const loginRedirect = config.identityServer.authority;

    return (
        <div className="session-expired-error">
            <div className="content">
                <div className="header">
                    <div className="logo">
                        <a href={docuwareBaseUrl}>
                            <img src={docuwareLogoBig} className="logo-big"></img>
                            <img src={docuwareLogo} className="logo-small"></img>
                        </a>
                    </div>
                    <IconButtonRounded className="close-icon" fill="red" onClick={_redirectToPreviousUrl} />
                </div>
                <img src={sessionExpiredImage} className="error-icon session_expired"></img>
                <h1 className="message">
                    <Translation>{t => t("Sorry, your session ended")}</Translation>
                </h1>
                <p className="detail">
                    <Translation>{t => t("To keep up your work you will need to log in again. We will redirect you to the login page.")}</Translation>
                </p>
                <div className="buttons">
                    <a href={loginRedirect}>
                        <button className="btn btn-primary" >
                            <Translation>{t => t("Ok")}</Translation>
                        </button>
                    </a>
                </div>
            </div>
        </div>
    )
}